import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  grid: {},
  thumbnail: {
    height: 60,
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  imageContainer: {
    margin: 'auto',
    height: 200,
    width: '80%',
    border: 'solid gray',
    boxShadow: `0.1em 0.1em 0.5em rgb(64, 64, 70)`,
    borderRadius: 10,
  },
  image: {
    height: '100%',
    width: '100%',
    border: 'solid gray 1px',
    borderRadius: 10,
  },
  label: {
    fontWeight: 'bold !important',
    marginRight: '10px !important ',
  },
  resultContainer: {
    padding: 20,
    flex: 1,
  },
}))
